import '@webcomponents/webcomponentsjs/webcomponents-loader'
import { gsap } from 'gsap'

import 'styles/styles.scss'

// Hide body to prevent FOUC
document.body.style.opacity = 0

WebComponents.waitFor(async () => {
  gsap.to(document.body, 0.35, { delay: .5, alpha: 1 })
  return import('./App.js')
})
